module.exports = __webpack_public_path__ + "static/media/trekke_fra.0c7f8d1b.m4a";